angular.module('bmsApp.settings').controller('MailchimpCtrl',
	function ($scope, MailchimpSvc, MailchimpCampaignSvc, SettingSvc, CustomerGroupSvc, $stateParams, $state, $timeout, $filter, DocumentSvc, $q, AppSettingsSvc) {

        $scope.data = {
            list: null,
			customerGroup: null,
			mailchimpCampaign: {
				name: 'x',
				from_address: '',
				from_name: '',
				subject: '',
				body: '',
				attachment: '',
				attachment_description: '',
				mailchimp_campaign_id: null,
				mailchimp_list_id: null,
				mailchimp_list_name: null,
				customer_group_id: null,
			},
			draftEmailAddress: null,
        };

		$scope.mailchimp = {
			documents: [],
			lists: {
				loading: null,
				refreshing: null,
				data: null,
			},
			subscribers: {
				updateMessage : false,
				importLoading: null,
				removeLoading: null,
			},
			draft: {
				sent: false,
				sending: null,
				updateMessage: false,
			},
			campaign: {
				sent: false,
				sending: null,
			},
			apiKey: {
				loading: null,
				verified: null,
			},
			customerGroups: {
				loading: null,
				data: null,
			},
		};

		$scope.action = {
			listChange: function() {
				$scope.accordion.expand(1);
				$scope.accordion.expand(2);
				$scope.data.mailchimpCampaign.mailchimp_list_id = $scope.data.list.id;
				$scope.data.mailchimpCampaign.mailchimp_list_name = $scope.data.list.name;
			},
			listUpdate: function() {
				$scope.mailchimp.lists.updateMessage = true;
				$scope.mailchimp.lists.refreshing = true;
				updateListInfo()
					.then(function(){
						$scope.mailchimp.lists.refreshing = false;
					});
			},
			removeAllSubscribers: function(){
				removeSubscribers($scope.data.list).then(function(){
					$scope.mailchimp.lists.refreshing = true;
					updateListInfo()
						.then(function(){
							$scope.mailchimp.lists.refreshing = false;
							$scope.mailchimp.lists.updateMessage = true;
						});
				});
			},
			importSubscribers: function(){
				importCustomerGroupToList($scope.data.list, $scope.data.customerGroup)
					.then(function(){
					$scope.mailchimp.lists.refreshing = true;
					updateListInfo()
						.then(function(){
							$scope.mailchimp.lists.refreshing = false;
							$scope.mailchimp.lists.updateMessage = true;
						});
				});
			},
			removeAllSubscribersAndImportSubscribers: function() {
				var removeSubscribersPromise = removeSubscribers($scope.data.list);
				if (removeSubscribersPromise) {
					removeSubscribersPromise
						.then(function() {
							importCustomerGroupToList($scope.data.list, $scope.data.customerGroup)
								.then(function() {
								});
						});
				}
				else {
					importCustomerGroupToList($scope.data.list, $scope.data.customerGroup)
						.then(function() {
						});
				}
			},
			saveAndContinue: function() {
				$scope.mailchimp.campaign.saving = true;
				$scope.data.mailchimpCampaign.customer_group_id = $scope.data.customerGroup.id;
				MailchimpCampaignSvc
					.save($scope.data.mailchimpCampaign)
					.then(function(response) {
						$scope.data.mailchimpCampaign = response.data.mailchimp_campaign;
						if (!$scope.data.draftEmailAddress) {
							$scope.data.draftEmailAddress = $scope.data.mailchimpCampaign.from_address;
						}
						MailchimpSvc
							.saveCampaign($scope.data.mailchimpCampaign)
							.then(function(response) {
								$scope.data.mailchimpCampaign = response.data.mailchimp_campaign;
								$scope.mailchimp.campaign.saving = false;
								$scope.accordion.collapse(0);
								$scope.accordion.collapse(1);
								$scope.accordion.collapse(2);
								$scope.accordion.expand(3);
							});
					});
			},
			editCampaign: function() {
				$scope.accordion.expand(0);
				$scope.accordion.expand(1);
				$scope.accordion.expand(2);
				$scope.accordion.collapse(3);
				$scope.accordion.collapse(4);
			},
			sendDraft: function() {
				$scope.mailchimp.draft.sending = true;
				MailchimpSvc
					.sendDraft({
						mailchimp_campaign: $scope.data.mailchimpCampaign,
						emails: [$scope.data.draftEmailAddress]
					})
					.then(function(response) {
						$scope.mailchimp.draft.updateMessage = true;
						$scope.mailchimp.draft.sent = true;
						$scope.mailchimp.draft.sending = false;
					});
			},
			continueToSend: function() {
				$scope.accordion.expand(4);
			},
			sendForReal: function() {
				$scope.mailchimp.campaign.sending = true;
				MailchimpSvc
					.sendCampaign($scope.data.mailchimpCampaign)
					.then(function(response) {
						$scope.mailchimp.campaign.sending = false;
						$scope.mailchimp.campaign.sent = true;
					});
			}
		};

		function updateListInfo() {
			return MailchimpSvc
				.getListsInfo()
				.then(function(response) {
					$timeout(function() {
						$scope.$apply(function() {
							$scope.mailchimp.lists.data = response.data.lists;
							if ($scope.mailchimp.lists.data.length == 1) {
								$scope.data.list = $scope.mailchimp.lists.data[0];
								$scope.action.listChange();
							}
						});
					}, 0);
				}, function(error) {
					$scope.errors = error;
				});
		}

		function importCustomerGroupToList(list, customerGroup) {
			$scope.mailchimp.subscribers.importLoading = true;
			return MailchimpSvc
				.importSubscribers({
					listId: list.id,
					customerGroupId: customerGroup.id
				})
				.then(function(response){
					$scope.mailchimp.subscribers.importLoading = false;
				});
		}

		function removeSubscribers(list) {
			if (list.subscribers != 0) {
				$scope.mailchimp.subscribers.removeLoading = true;
				return MailchimpSvc
					.removeAllListSubscribers({
						listId: list.id,
					})
					.then(function(response){
						$scope.mailchimp.subscribers.removeLoading = false;
					});
			}
		}

		//function saveCampaign(mailchimpCampaign) {
		//	var promises = [MailchimpCampaignSvc.save(mailchimpCampaign), MailchimpSvc.saveCampaign(mailchimpCampaign)];
		//	return $q.all(promises);
		//}

        // Get lists
		$scope.mailchimp.lists.loading = true;
		$scope.mailchimp.apiKey.loading = true;
		AppSettingsSvc
			.index()
			.then(function(response) {
				var mailchimpData = response.data;
				if (mailchimpData.settings.mailchimp_apikey_verified == 1) {
					$scope.data.mailchimpCampaign.from_address = mailchimpData.settings.smtp_server_username;
					$scope.mailchimp.apiKey.verified = true;
					$scope.mailchimp.lists.loading = true;
					updateListInfo().then(function(){$scope.mailchimp.lists.loading = false;});
				}
				else {
					$scope.mailchimp.apiKey.verified = false;
				}
				$scope.mailchimp.apiKey.loading = false;
			}, function(error) {
				$scope.errors = error;
			});

		// Get customer groups
		CustomerGroupSvc
			.index()
			.then(function(response){
				$scope.mailchimp.customerGroups.data = response.data.customer_group_collection;
				var filter = $filter('filter')($scope.mailchimp.customerGroups.data, {id: $stateParams.id});
				if (filter.length == 1) {
					$scope.data.customerGroup = $filter('filter')($scope.mailchimp.customerGroups.data, {id: $stateParams.id})[0];
				}
			});

		// Get files
		DocumentSvc.options({}).then(function (response) {
			$timeout(function () {
				$scope.$apply(function () {
					$scope.mailchimp.documents = response.data.options;
				});
			}, 0);
		});
	});
